import { render, staticRenderFns } from "./rules-hostess.vue?vue&type=template&id=28c9b7af&scoped=true"
import script from "./rules-hostess.vue?vue&type=script&lang=js"
export * from "./rules-hostess.vue?vue&type=script&lang=js"
import style0 from "./rules-hostess.vue?vue&type=style&index=0&id=28c9b7af&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c9b7af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28c9b7af')) {
      api.createRecord('28c9b7af', component.options)
    } else {
      api.reload('28c9b7af', component.options)
    }
    module.hot.accept("./rules-hostess.vue?vue&type=template&id=28c9b7af&scoped=true", function () {
      api.rerender('28c9b7af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P4_Page/BaseRules/rules-hostess.vue"
export default component.exports